module.exports = __webpack_public_path__ + "static/media/homeBanner.724a1fa3.png";